import { AfterContentInit, Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Parser } from 'expr-eval';
import * as _ from 'lodash';
import { db } from 'src/app/db/db';
import { AspectAbord } from 'src/app/domain/SANDRE/aspect-abord';
import { ColmatageLit } from 'src/app/domain/SANDRE/colmatage-lit';
import { EEnsoleillement } from 'src/app/domain/SANDRE/ensoleillement';
import { Hydrologie } from 'src/app/domain/SANDRE/hydrologie';
import { EImportanceVegetationBerge } from 'src/app/domain/SANDRE/importance-vegetation-berge';
import { Limpidite } from 'src/app/domain/SANDRE/limpidite';
import { EMeteo } from 'src/app/domain/SANDRE/meteo';
import { NatureBergeDroite } from 'src/app/domain/SANDRE/nature-berge-droite';
import { NatureBergeGauche } from 'src/app/domain/SANDRE/nature-berge-gauche';
import { OccupationDominanteRiveGauche } from 'src/app/domain/SANDRE/occ-dominanteRG';
import { OccupationDominanteRiveDroite } from 'src/app/domain/SANDRE/occDominanteRD';
import { Odeur } from 'src/app/domain/SANDRE/odeur';
import { PresenceGué } from 'src/app/domain/SANDRE/presence-gue';
import { PresenceSeuil } from 'src/app/domain/SANDRE/presence-seuil';
import { PresenceRejet } from 'src/app/domain/SANDRE/presense-rejet';
import { SituationHydrologie6sem } from 'src/app/domain/SANDRE/situation-hydro-6sem';
import { Teinte } from 'src/app/domain/SANDRE/teinte';
import { ETypeVegetation } from 'src/app/domain/SANDRE/type-vegetation-name';
import { VariationDebit } from 'src/app/domain/SANDRE/variation-debit';
import { VisibiliteFond } from 'src/app/domain/SANDRE/visibilite-fond';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { MasterSonde } from 'src/app/domain/Shared/master-sonde';
import { ESecuriteMiseALEau } from 'src/app/domain/description/securite-mise-eau';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Intervention } from 'src/app/domain/planning/intervention';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { EnvironmentService } from 'src/app/services/environment-service';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';
import { CoreData } from 'src/app/tools/core-data';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-description-station',
    templateUrl: './description-station.component.html',
    styleUrls: ['./description-station.component.scss']
})
export class DescriptionStationComponent implements OnInit, AfterContentInit {
    EInterventionType = EInterventionType;
    ESecuriteMiseALeau = ESecuriteMiseALEau;
    SondeList: MasterSonde[] = [];
    private MAX_WATER_TEMPERATURE = 30;
    private PH_MIN = 5;
    private PH_MAX = 10;

    private CONDUCTIVITY_MIN = 10;
    private CONDUCTIVITY_MAX = 1500;

    private OXYGEN_MAX = 13;

    private SATURATION_MIN = 13;
    private SATURATION_MAX = 150;

    public model: Intervention = new Intervention();
    WaterTemperatureControl = new UntypedFormControl('', Validators.compose([
        Validators.max(this.MAX_WATER_TEMPERATURE)]));

    PHControl = new UntypedFormControl('', Validators.compose([
        Validators.min(this.PH_MIN),
        Validators.max(this.PH_MAX)]));

    ConductivityControl = new UntypedFormControl('', Validators.compose([
        Validators.min(this.CONDUCTIVITY_MIN),
        Validators.max(this.CONDUCTIVITY_MAX)]));

    OxygenControl = new UntypedFormControl('', Validators.compose([
        Validators.max(this.OXYGEN_MAX)]));

    SaturationControl = new UntypedFormControl('', Validators.compose([
        Validators.min(this.SATURATION_MIN),
        Validators.max(this.SATURATION_MAX)]));

    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save'
            },
        ];
    public MeteoList: string[] = Object.values(EMeteo).filter(x => !isNaN(Number(x))).map(x => StringConverter.getMeteoName(x as EMeteo));

    public EnsoleillementList: string[] =
        Object.values(EEnsoleillement)
            .filter(x => !isNaN(Number(x)))
            .map((x: EEnsoleillement) => StringConverter.getEnsoleillementName(x));

    public HydrologieList: string[] =
        Object.values(Hydrologie)
            .filter(x => !isNaN(Number(x)))
            .map((x: Hydrologie) => StringConverter.getHydrologieName(x));

    public SecuriteMiseEauList: string[] =
        Object.values(ESecuriteMiseALEau)
            .filter(x => !isNaN(Number(x)))
            .map((x: ESecuriteMiseALEau) => StringConverter.getSecuriteMiseEauName(x));

    public VariationDebitList: string[] =
        Object.values(VariationDebit)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getVariationDebitName(x as VariationDebit));

    public LimpiditeList: string[] = Object.values(Limpidite).filter(x => !isNaN(Number(x))).map(x => StringConverter.getLimpiditeName(x as Limpidite));

    public VisibiliteList: string[] =
        Object.values(VisibiliteFond)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getVisibiliteName(x as VisibiliteFond));
    public OdeurList: string[] = Object.values(Odeur).filter(x => !isNaN(Number(x))).map(x => StringConverter.getOdeurName(x as Odeur));

    public TeinteList: string[] = Object.values(Teinte).filter(x => !isNaN(Number(x))).map(x => StringConverter.getTeinteName(x as Teinte));

    public SituationHydro6semList: string[] =
        Object.values(SituationHydrologie6sem)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getSituationHydrologie6semName(x as SituationHydrologie6sem));

    public ODRGList: string[] =
        Object.values(OccupationDominanteRiveGauche)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getODRGName(x as OccupationDominanteRiveGauche));

    public ODRDList: string[] =
        Object.values(OccupationDominanteRiveDroite)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getODRDName(x as OccupationDominanteRiveDroite));

    public NatureBergeGaucheList: string[] =
        Object.values(NatureBergeGauche)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getNatureBergeGaucheName(x as NatureBergeGauche));

    public NatureBergeDroiteList: string[] =
        Object.values(NatureBergeDroite)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getNatureBergeDroiteName(x as NatureBergeDroite));

    public AspectAbordList: string[] =
        Object.values(AspectAbord)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getAspectAbordsName(x as AspectAbord));

    public PresenceSeuilList: string[] =
        Object.values(PresenceSeuil)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getPresenceSeuilName(x as PresenceSeuil));

    public PresenceGueList: string[] =
        Object.values(PresenceGué)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getPresenceGueName(x as PresenceGué));

    public ColmatageLitList: string[] =
        Object.values(ColmatageLit)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getColmatageLitName(x as ColmatageLit));

    public PresenceRejetList: string[] =
        Object.values(PresenceRejet)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getPresenceRejetName(x as PresenceRejet));

    public VegetationTypetList: string[] =
        Object.values(ETypeVegetation)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.GetTypeVegetationName(x as ETypeVegetation));

    public ImportanceVegetationList: string[] =
        Object.values(EImportanceVegetationBerge)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.GetImportanceVegetationBergeName(x as EImportanceVegetationBerge));

    get SondePhList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.PH);
    }
    get SondeOxygeneList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.Oxygene);
    }
    get SondeConductiviteList() {
        return this.SondeList.filter(x => x.Type === EMasterSondeType.Conductivite);
    }

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        private masterSondeService: MasterSondeService,
        public coreData: CoreData,
        private router: Router,
        private environmentService: EnvironmentService,
        private route: ActivatedRoute) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // if (this.coreData.IsOffline) {
                //     this.coreData.setOfflineInterventionDescription(this.model.Code, this.model);
                // } else {
                //     this.save();
                // }
            }
        })
    }

    ngOnInit() {
        this.WaterTemperatureControl.markAsDirty();
        this.ConductivityControl.markAsDirty();
        this.SaturationControl.markAsDirty();
        this.PHControl.markAsDirty();
        this.OxygenControl.markAsDirty();
    }

    async ngAfterContentInit() {
        if (!this.route.snapshot.params.interventionCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        if (this.coreData.IsOffline) {
            this.SondeList = await db.getAllSondes();
            this.model = this.coreData.getOfflineInterventionDescription(this.route.snapshot.params.interventionCode);
            this.model.Code = this.route.snapshot.params.interventionCode;
            this.model.Type = Number(this.route.snapshot.params.type) as EInterventionType;
        } else {
            this.getAllSonde();
            this.environmentService.getEnvironment(this.route.snapshot.params.interventionCode).subscribe((i) => {
                this.model = i;
                this.model.Code = this.route.snapshot.params.interventionCode;
                this.model.Type = Number(this.route.snapshot.params.type) as EInterventionType;
            });
        }
        if (this.model.Type === EInterventionType.EAU) {
            this.model.PhysiqueChimieInSitu.COFRACConductivite = true;
            this.model.PhysiqueChimieInSitu.COFRACOxygeneDissous = true;
            this.model.PhysiqueChimieInSitu.COFRACSaturationO2d = true;
            this.model.PhysiqueChimieInSitu.COFRACTemperatureEau = true;
            this.model.PhysiqueChimieInSitu.COFRACpH = true;
        }
    }

    computeTemperatureFormula(tempBrute: number) {
        if (!this.SondeList || this.SondeList.length === 0 || !tempBrute) {
            return;
        }
        let formula: string = '';
        if (this.model.PhysiqueChimieInSitu.SondePh)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.model.PhysiqueChimieInSitu.SondePh))?.FacteurCorrection;
        else if (this.model.PhysiqueChimieInSitu.SondeConductivite)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.model.PhysiqueChimieInSitu.SondeConductivite))?.FacteurCorrection;
        else if (this.model.PhysiqueChimieInSitu.SondeOxygene)
            formula = _.first(this.SondeList.filter(x => x.Reference === this.model.PhysiqueChimieInSitu.SondeOxygene))?.FacteurCorrection;

        if (!formula)
            return 0;

        var expression = Parser.parse(formula);
        var result = expression.evaluate({ x: tempBrute });
        return result;
    }

    getAllSonde() {
        this.masterSondeService.getActiveSonde().subscribe(x => {
            this.SondeList = x;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeConductivite = this.coreData.getLastSondeCondRef() ?? _.first(this.SondeConductiviteList)?.Reference;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondeOxygene = this.coreData.getLastSondeOxyRef() ?? _.first(this.SondeOxygeneList)?.Reference;
            // this.LacProcess.PhysiqueChimieInSitu.Sonde.SondePh = this.coreData.getLastSondePhRef() ?? _.first(this.SondePhList)?.Reference;
        });
    }

    public compareWith(m1: string, m2: string) {
        return  m1 === m2;
    }

    save() {
        this.environmentService.putEnvironment(this.model).subscribe(() => {
        });
    }

    dispatch(event: SpeedDialFabModel) {
        if (event.Id === 0) {
            if (this.coreData.IsOffline) {
                this.coreData.setOfflineInterventionDescription(this.model.Code, this.model);
            } else {
                this.save();
            }
        }
    }
}
